import React from "react";
import { Link } from "react-router-dom";

const NavbarLogo = ({ loading, logo }) => {
  return (
    <Link to="/" className="flex items-center group h-full">
      {loading ? (
        <div className="h-20 w-48 bg-slate-200 animate-pulse rounded-lg" />
      ) : logo ? (
        <img
          src={logo}
          alt="Logo"
          className="h-24 xl:h-32 w-auto object-contain transition-all group-hover:scale-105"
        />
      ) : (
        <div className="h-24 xl:h-32 px-10 flex flex-col items-center justify-center bg-transparent transition-all duration-300 group-hover:bg-blue-50/5">
          <span className="text-[14px] xl:text-[16px] font-black tracking-[0.2em] text-slate-800 dark:text-slate-200 uppercase leading-none mb-1.5 text-center">
            Pasang Logo
          </span>
          <span className="text-[10px] xl:text-[11px] font-medium tracking-[0.3em] text-blue-500 uppercase leading-none opacity-80 text-center">
            Anda Disini
          </span>
        </div>
      )}
    </Link>
  );
};

export default NavbarLogo;